import React from 'react';
import {Chip, Stack, Typography} from '@mui/material';
import {getClassificationByValue} from '../../../components/prosemirror-editor/helpers/classificationLevels';

const CHIP_SX = {
    height: 20,
    alignSelf: 'flex-start',
    minWidth: 28,
    fontWeight: 700,
    '& .MuiChip-label': {px: 0.75},
};

/**
 * Read-only Classification Level / Distribution / Compartment, inherited from the parent
 * Collection Task. Used by Add Material dialogs so collectors cannot override the task's
 * markings at upload time — edit the task instead.
 */
export default function InheritedClassificationDisplay({
    level = 'U',
    distribution = [],
    compartment = [],
}) {
    const levelInfo = level ? getClassificationByValue(level) : null;
    const dist = Array.isArray(distribution) ? distribution.filter(Boolean) : [];
    const comp = Array.isArray(compartment) ? compartment.filter(Boolean) : [];

    const renderTags = (tags) => {
        if (tags.length === 0) {
            return (
                <Typography variant="body2" color="text.disabled" sx={{fontStyle: 'italic'}}>
                    Not set
                </Typography>
            );
        }
        return (
            <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap alignItems="center">
                {tags.map((tag) => (
                    <Chip
                        key={tag}
                        size="small"
                        variant="outlined"
                        label={tag}
                        sx={{height: 20, minWidth: 28, '& .MuiChip-label': {px: 0.75}}}
                    />
                ))}
            </Stack>
        );
    };

    return (
        <Stack spacing={1} data-testid="inherited-classification">
            <Typography variant="subtitle2" color="text.secondary">
                Classification
            </Typography>
            <Typography variant="caption" color="text.secondary">
                Inherited from the Collection Task — not editable here.
            </Typography>
            <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
                <Stack spacing={0.25} sx={{minWidth: 100}}>
                    <Typography variant="caption" color="text.secondary">Classification Level</Typography>
                    {level ? (
                        <Chip
                            size="small"
                            label={levelInfo ? levelInfo.value : level}
                            sx={{
                                ...CHIP_SX,
                                color: levelInfo?.color,
                                bgcolor: levelInfo?.bgColor,
                            }}
                        />
                    ) : (
                        <Typography variant="body2" color="text.disabled" sx={{fontStyle: 'italic'}}>
                            Not set
                        </Typography>
                    )}
                </Stack>
                <Stack spacing={0.25} sx={{minWidth: 100}}>
                    <Typography variant="caption" color="text.secondary">Distribution</Typography>
                    {renderTags(dist)}
                </Stack>
                <Stack spacing={0.25} sx={{minWidth: 100}}>
                    <Typography variant="caption" color="text.secondary">Compartment</Typography>
                    {renderTags(comp)}
                </Stack>
            </Stack>
        </Stack>
    );
}
